/***
 *
 *   BRAND RAMP PREVIEW
 *   The ten derived stops as swatches, with "Aa" in white over the four that
 *   carry white text in the app.
 *
 *   This is the admin's only window onto the contrast clamp. utilities/brand.js
 *   accepts any hex and then DARKENS stops 600-900 until white text on them
 *   clears AA — so a tenant who enters a bright yellow gets something
 *   noticeably darker than they picked. Showing it here means they find that
 *   out while they are choosing, rather than being surprised by the live page.
 *
 *   PROPS
 *   color: the hex being previewed
 *   label: heading above the swatches
 *
 **********/

import { deriveBrandRamp } from 'utilities/brand';
import Style from './brandRampPreview.tailwind.js';

const STOPS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

// The stops the app puts small white text on — bg-primary, the auth panel
// gradient, and the accent button after its one-stop shift.
const WHITE_TEXT_STOPS = [600, 700, 800, 900];

export function BrandRampPreview(props) {
    const ramp = deriveBrandRamp(props.color);

    if (!ramp) return null;

    return (
        <div className={Style.wrapper}>
            {props.label && <p className={Style.label}>{props.label}</p>}

            <div className={Style.ramp}>
                {STOPS.map((stop) => (
                    <div
                        key={stop}
                        className={Style.swatch}
                        // Inline because the value is computed per keystroke —
                        // there is no class for an arbitrary tenant hex.
                        style={{ backgroundColor: `hsl(${ramp[stop]})` }}
                        title={`${stop} — hsl(${ramp[stop]})`}>
                        {WHITE_TEXT_STOPS.includes(stop) && (
                            <span className={Style.sample}>Aa</span>
                        )}
                    </div>
                ))}
            </div>

            <div className={Style.scale} aria-hidden>
                {STOPS.map((stop) => (
                    <span key={stop} className={Style.step}>
                        {stop}
                    </span>
                ))}
            </div>
        </div>
    );
}
